import Repository from './Repository';

const resource = '/desempenhos';

export default {
  get(diagnostico) {
    return Repository.get(`${resource}/usuario?diagnostico=${diagnostico}`);
  },

  getAll(diagnostico, comissao) {
    return Repository.get(`${resource}/?diagnostico=${diagnostico}&comissao=${comissao}`);
  },

  getByUnidades(diagnosticoId, unidadesIds) {
    const unidadesParam = unidadesIds.reduce((acumulador, u) => acumulador.concat(`&unidade=${u}`), '');
    return Repository.get(`${resource}/unidades?diagnostico=${diagnosticoId}${unidadesParam}`);
  },
};
